var __TEMP__ = require('./_LazyWrapper.js');var LazyWrapper = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_LodashWrapper.js');var LodashWrapper = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_copyArray.js');var copyArray = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = wrapperClone;
